import { render, staticRenderFns } from "./FormTags.vue?vue&type=template&id=4d9a60fb&"
import script from "./FormTags.vue?vue&type=script&lang=js&"
export * from "./FormTags.vue?vue&type=script&lang=js&"
import style0 from "./FormTags.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports